// Localised dietary tag labels (vegetarian, vegan, gluten-free, etc.).
// Used by DietTab to show pills in the user's language.
// Falls back to the original tag text if no translation is provided.

const T = {
  'vegetarian':   { ru: 'Вегетарианское', uk: 'Вегетаріанське', ko: '채식', fr: 'Végétarien', it: 'Vegetariano', es: 'Vegetariano' },
  'vegan':        { ru: 'Веганское', uk: 'Веганське', ko: '비건', fr: 'Végan', it: 'Vegano', es: 'Vegano' },
  'gluten-free':  { ru: 'Без глютена', uk: 'Без глютену', ko: '글루텐-프리', fr: 'Sans gluten', it: 'Senza glutine', es: 'Sin gluten' },
  'dairy-free':   { ru: 'Без молочных продуктов', uk: 'Без молочних продуктів', ko: '유제품-프리', fr: 'Sans produits laitiers', it: 'Senza latticini', es: 'Sin lácteos' },
  'high-protein': { ru: 'Высокобелковое', uk: 'Висококалорійне', ko: '고단백', fr: 'Riche en protéines', it: 'Ricco di proteine', es: 'Alto en proteínas' },
  'high-fibre':   { ru: 'Высоковолокнистое', uk: 'З високим вмістом клітковини', ko: '고섬유질', fr: 'Riche en fibres', it: 'Ricco di fibre', es: 'Alto en fibra' },
  'omega-3':      { ru: 'Омега-3', uk: 'Омега-3', ko: '오메가-3', fr: 'Oméga-3', it: 'Omega-3', es: 'Omega-3' },
  'low-carb':     { ru: 'Низкоуглеводное', uk: 'З низьким вмістом вуглеводів', ko: '저탄수화물', fr: 'Faible en glucides', it: 'Pochi carboidrati', es: 'Bajo en carbohidratos' },
  'budget':       { ru: 'Бюджетное', uk: 'Бюджетне', ko: '저렴한', fr: 'Économique', it: 'Economico', es: 'Económico' },
  'quick':        { ru: 'Быстрое', uk: 'Швидке', ko: '빠른', fr: 'Rapide', it: 'Veloce', es: 'Rápido' },
  'mood-support': { ru: 'Поддержка настроения', uk: 'Підтримка настрою', ko: '기분 개선', fr: 'Soutien de l\'humeur', it: 'Sostegno dell\'umore', es: 'Apoyo del ánimo' },
};

export function localizedTag(tag, langCode) {
  if (!langCode || langCode === 'en') return tag;
  return (T[tag] && T[tag][langCode]) || tag;
}
